import * as Yup from 'yup';

export const schema = Yup.object().shape({
  ApplicationDomainHostName: Yup.string().required('دامنه ضروری است'),
});
